import { render, staticRenderFns } from "./promote_label_modal.vue?vue&type=template&id=7688376d&"
import script from "./promote_label_modal.vue?vue&type=script&lang=js&"
export * from "./promote_label_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "promote_label_modal.vue"
export default component.exports